module.exports = __webpack_public_path__ + "static/favicon-03fbcc437a426eb66ec33363e78a8894.png";